import { createGlobalStyle } from "./styled-components";

export const Styles = createGlobalStyle`

    /* @font-face {
        font-family: "Motiva Sans Light";
        src: url("/fonts/Motiva-Sans-Light.ttf") format("truetype");
        font-style: normal;
    }

    @font-face {
        font-family: "Motiva Sans Bold";
        src: url("/fonts/Motiva-Sans-Bold.ttf") format("truetype");
        font-style: normal;
    } */

    @font-face {
        font-family: "IBM";
        src: url("/fonts/IBMPlexMono-Regular.ttf") format("truetype");
        font-style: normal;
    }

    @font-face {
        font-family: "Lato";
        src: url("/fonts/Lato-Regular.ttf") format("truetype");
        font-style: normal;
    }

    body,
    html,
    a {
        font-family: 'IBM', sans-serif;
    }


    body {
        margin:0;
        padding:0;
        border: 0;
        outline: 0;
        background: ${(props) => props.theme.colors.background};
        overflow-x: hidden;
    }

    a:hover {
        color: ${(props) => props.theme.colors.primary};
    }

    input,
    textarea {
        border-radius: 4px;
        border: 0;
        background: ${(props) => props.theme.colors.background};
        transition: all 0.3s ease-in-out;  
        outline: none;
        width: 100%;  
        padding: 1rem 1.25rem;

        :focus-within {
            background: none;
            box-shadow: ${(props) =>
              props.theme.colors.primary} 0px 0px 0px 1px;
        }
    }

    h1,
    h2,
    h3 {
        font-family: 'Lato', serif;
        color: ${(props) => props.theme.colors.primary};
        font-size: 36px;
        line-height: 1.18;

        @media only screen and (max-width: 890px) {
          font-size: 28px;
        }
      
        @media only screen and (max-width: 414px) {
          font-size: 22px;
        }
    }

    h4,
    h5,
    h6 {
        font-family: 'IBM', serif;
        color: ${(props) => props.theme.colors.primary};
        font-size: 24px;
        line-height: 1.03;

        @media only screen and (max-width: 890px) {
          font-size: 20px;
        }
      
        @media only screen and (max-width: 414px) {
          font-size: 16px;
        }
    }

    p {
        color: ${(props) => props.theme.colors.text};
        font-size: 14px;        
        line-height: 1.41;
    }

    h1 {
        font-weight: 600;
    }

    a {
        text-decoration: none;
        outline: none;
        color: ${(props) => props.theme.colors.primary};

        :hover {
            color: ${(props) => props.theme.colors.secondary};
        }
    }
    
    *:focus {
        outline: none;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }
`;
